import { SeatPictogram } from '@/components/icons/SeatPictogram';
import { Icons, type IconProps } from '@packages/webshop-design-system';

type PlaceIconName = 'seat' | 'compartment' | 'bed';

type PlacePictogramProps = IconProps & {
  placeIcon?: PlaceIconName;
};

/** Place-type pictogram (seat / bed / compartment); seat uses TIF branding when applicable. */
export const PlacePictogram = ({
  placeIcon = 'seat',
  ...props
}: PlacePictogramProps) => {
  if (placeIcon === 'seat') {
    return <SeatPictogram {...props} />;
  }

  const Icon = Icons[placeIcon];
  return <Icon {...props} />;
};
